module.exports = __webpack_public_path__ + "img/react-color.45ac96ff.svg";